/* Native disclosure navigation + swipeable carousel. No dependencies. */
if (!customElements.get('evx-slideshow')) {
  customElements.define('evx-slideshow', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.evx-slides');
      this.slides = [...this.querySelectorAll('.evx-slide')];
      this.dots = [...this.querySelectorAll('[data-slide-index]')];
      this.index = 0;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-slide-step], [data-slide-index]');
        if (!button) return;
        const next = button.hasAttribute('data-slide-index') ? Number(button.dataset.slideIndex) : this.index + Number(button.dataset.slideStep);
        this.go(next);
      });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.dots.forEach((dot, i) => i === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        });
      }, {passive:true});
      this.onBlockSelect = event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target) || slide === event.target);
        if (index >= 0) this.go(index);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }
    go(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({left:this.index*this.track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); document.removeEventListener('shopify:block:select', this.onBlockSelect); }
  });
}
function initElectrovox(scope = document) {
  scope.querySelectorAll('.evx-navigation').forEach(nav => {
    if(nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const disclosure = nav.querySelector('.evx-nav-mobile');
    const desktop = matchMedia('(min-width:990px)');
    disclosure.open = desktop.matches;
    desktop.addEventListener('change', () => { if (nav.isConnected) disclosure.open = desktop.matches; });
    const items = [...nav.querySelectorAll('.evx-nav-item')];
    items.forEach(item => {
      item.addEventListener('toggle', () => {
        if(item.open) items.forEach(other => { if(other !== item) other.open = false; });
      });
      let timer;
      item.addEventListener('pointerenter', event => {
        if(event.pointerType === 'mouse' && matchMedia('(min-width:990px)').matches) { clearTimeout(timer); item.open = true; }
      });
      item.addEventListener('pointerleave', event => {
        if(event.pointerType === 'mouse' && matchMedia('(min-width:990px)').matches) timer = setTimeout(() => { if(!item.contains(document.activeElement)) item.open = false; },160);
      });
    });
    nav.addEventListener('keydown', event => {
      if(event.key !== 'Escape') return;
      const open = event.target.closest('details[open]');
      if(open) {open.open = false;open.querySelector('summary').focus();event.stopPropagation();}
    });
  });
}
initElectrovox();
document.addEventListener('shopify:section:load', event => initElectrovox(event.target));
document.addEventListener('click', event => {if(!event.target.closest('.evx-navigation')) document.querySelectorAll('.evx-nav-item[open]').forEach(item => {item.open=false;});});

document.addEventListener('click', event => {
  const button = event.target.closest('[data-row-step]');
  if (!button) return;
  const row = button.closest('.evx-product-row')?.querySelector('.evx-grid');
  if (row) row.scrollBy({left: Number(button.dataset.rowStep) * row.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});
